<template>
  <div class="artwork-container">
    <slot></slot>

    <div class="splash" v-if="!value || !value.results.length">
      <div class="artworks"></div>

      <div v-if="!value">
        <font-awesome-icon slot="spinner" icon="spinner" size="2x" pulse />
      </div>
      <div v-else-if="!value.results.length">
        결과가 없습니다.
      </div>
    </div>

    <template v-else>
      <div class="artworks">
        <artwork
          :key="artwork.id"
          :artwork="artwork"
          :fixed-layout="fixedLayout"
          :invite="invite"
          :selected="selected"
          :index="index"
          v-for="(artwork, index) in value.results"
          @update="update"
          @remove="remove"
        />
      </div>
      <infinite-loading
        :identifier="identifier"
        @infinite="infinite"
        ref="infiniteLoading"
      >
        <div slot="spinner" class="p-5">
          <font-awesome-icon slot="spinner" icon="spinner" size="2x" pulse />
        </div>
        <span slot="no-more" />
        <span slot="no-results" />
      </infinite-loading>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import Masonry from "masonry-layout";
import ImagesLoaded from "imagesloaded";
import InfiniteLoading from "vue-infinite-loading";
import ArtworkComponent from "./Artwork";
import { Artwork } from "../models";

export default Vue.component("Artworks", {
  components: {
    artwork: ArtworkComponent,
    InfiniteLoading
  },
  props: {
    value: Object,
    fixedLayout: {
      type: Boolean,
      default: true
    },
    invite: Object,
    selected: Boolean
  },
  data() {
    return {
      masonry: null,
      identifier: new Date()
    };
  },
  watch: {
    "value._isNoMore"(isNoMore) {
      if (isNoMore) {
        return;
      }

      this.identifier = new Date();
    },
    "value.results": {
      handler() {
        this.layout();
      },
      immediate: true
    },
    fixedLayout() {
      this.layout();
    }
  },
  methods: {
    layout() {
      if (this.fixedLayout) {
        if (this.masonry) {
          this.masonry.destroy();
          this.masonry = null;
        }

        return;
      }

      this.$nextTick(() => {
        ImagesLoaded(".card-img-top", () => {
          const grid = document.querySelector(".artworks");
          this.masonry = new Masonry(grid, {
            itemSelector: ".card"
          });

          this.masonry.layout();
        });
      });
    },
    update() {
      this.$emit("update");
    },
    async remove(index, deleted = true) {
      if (deleted) {
        await new Artwork({ id: this.value.results[index].id }).delete();
      }
      this.value.results.splice(index, 1);
    },
    async infinite($state) {
      const { _currentPage } = this.value;
      if (!this.value.loadMore) {
        $state.complete();
        return;
      }

      const artworks = await this.value.loadMore();
      if (artworks._currentPage === _currentPage) {
        $state.complete();
      } else {
        this.$emit("input", artworks);
        $state.loaded();
      }
    }
  },
  activated() {
    this.layout();
  }
});
</script>

<style lang="scss" scoped>
.artwork-container {
  margin: 0 auto;
  max-width: 100% !important;

  @media (min-width: 548px) {
    max-width: 548px !important;
  }

  @media (min-width: 812px) {
    max-width: 812px !important;
  }

  @media (min-width: 1076px) {
    max-width: 1076px !important;
  }

  @media (min-width: 1340px) {
    max-width: 1340px !important;
  }

  @media (min-width: 1604px) {
    max-width: 1604px !important;
  }

  @media (min-width: 1883px) {
    max-width: 1883px !important;
  }
}

.splash {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: rgba(0, 0, 0, 0.5);
}
</style>
